import React from 'react';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';

const StyledTable = ({
  columns = [],
  data = [],
  onRowClick,
  selectedRow,
  variant = 'gold',
  showCheckbox = false,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  className,
  emptyMessage = 'لا توجد بيانات',
  emptyIcon = 'Inbox',
}) => {
  const variantStyles = {
    gold: {
      header: 'bg-gradient-gold border-primary/20',
      headerText: 'text-primary',
      border: 'border-primary/25',
    },
    blue: {
      header: 'bg-gradient-blue border-blue-500/30',
      headerText: 'text-blue-400',
      border: 'border-blue-500/25',
    },
    green: {
      header: 'bg-gradient-green border-green-500/30',
      headerText: 'text-green-400',
      border: 'border-green-500/25',
    },
    amber: {
      header: 'bg-gradient-amber border-amber-500/30',
      headerText: 'text-amber-400',
      border: 'border-amber-500/25',
    },
    cyan: {
      header: 'bg-gradient-cyan border-cyan-500/30',
      headerText: 'text-cyan-400',
      border: 'border-cyan-500/25',
    },
    red: {
      header: 'bg-gradient-red border-red-500/30',
      headerText: 'text-red-400',
      border: 'border-red-500/25',
    },
  };

  const styles = variantStyles?.[variant] || variantStyles?.gold;

  const handleRowClick = (row, index) => {
    if (onRowClick) {
      onRowClick(row, index);
    }
  };

  const handleSelectRow = (e, rowId) => {
    e?.stopPropagation();
    if (onSelectRow) {
      onSelectRow(rowId);
    }
  };

  const handleSelectAll = (e) => {
    if (onSelectAll) {
      onSelectAll(e?.target?.checked);
    }
  };

  if (data?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name={emptyIcon} size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={cn('overflow-x-auto rounded-lg border', styles?.border, className)}>
      <table className="w-full border-collapse">
        <thead>
          <tr className={cn('rounded-t-lg', styles?.header, 'border-b', styles?.border)}>
            {showCheckbox && (
              <th className="p-3 text-right w-12">
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedRows?.length === data?.length && data?.length > 0}
                  className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
                />
              </th>
            )}
            {columns?.map((column, index) => (
              <th
                key={index}
                className={cn(
                  'p-3 text-right text-xs font-semibold uppercase tracking-wide',
                  styles?.headerText,
                  column?.className
                )}
                style={column?.style}
              >
                {column?.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border/30">
          {data?.map((row, rowIndex) => {
            const isSelected = selectedRow === row?.id || selectedRows?.includes(row?.id);
            return (
              <tr
                key={row?.id || rowIndex}
                onClick={() => handleRowClick(row, rowIndex)}
                className={cn(
                  'transition-all duration-200',
                  onRowClick && 'cursor-pointer',
                  'hover:bg-table-row-hover',
                  isSelected && 'bg-table-row-selected'
                )}
              >
                {showCheckbox && (
                  <td className="p-3" onClick={(e) => e?.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={selectedRows?.includes(row?.id)}
                      onChange={(e) => handleSelectRow(e, row?.id)}
                      className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
                    />
                  </td>
                )}
                {columns?.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={cn('p-3 text-sm text-foreground', column?.cellClassName)}
                    style={column?.cellStyle}
                  >
                    {column?.render ? column?.render(row, rowIndex) : row?.[column?.accessor]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StyledTable;